module.exports = __webpack_public_path__ + "img/reward-1.b0495846.svg";